import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const inspectJobDescription = createAsyncThunk("inspectJobDescription", async ({ job_id, inspect_type }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`jdoc/inspectjdesc?job_id=${job_id}&inspect_type=${inspect_type}`);
		return response?.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data?.message || "Something went wrong");
	}
});

const JobDescriptionInspectSlice = createSlice({
	name: "JobDescriptionInspectSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		successMessage: null,
	},
	reducers: {
		resetJobDescriptionInspect: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
			state.successMessage = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(inspectJobDescription.pending, (state) => {
			state.isLoading = true;
			state.error = null;
			state.successMessage = null;
		});
		builder.addCase(inspectJobDescription.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.error = null;
			state.successMessage = action?.payload?.message || "Action completed successfully";
		});
		builder.addCase(inspectJobDescription.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.successMessage = null;
		});
	},
});

export const { resetJobDescriptionInspect } = JobDescriptionInspectSlice.actions;
export default JobDescriptionInspectSlice.reducer;
